module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-independence-left-480a4416708eba963ea3e73928bdd863.svg";